<template>
  <v-card class="tn-panel">
    <div class="tn-panel__head"><v-icon size="20">mdi-account-outline</v-icon> Customer</div>
    <div class="tn-panel__body">
      <template v-if="customer">
        <div class="tn-person">
          <v-avatar size="40" color="navy"><span class="white--text font-weight-bold">{{ initials(customer.name) }}</span></v-avatar>
          <div class="tn-person__text">
            <div class="tn-person__name">{{ customer.name || 'No name on the account' }}</div>
            <div class="tn-muted">{{ customer.source || 'Customer account' }}</div>
          </div>
        </div>
        <div class="tn-contact">
          <a v-if="customer.email" :href="'mailto:' + customer.email"><v-icon size="18">mdi-email-outline</v-icon>{{ customer.email }}</a>
          <a v-if="customer.phone" :href="'tel:' + customer.phone"><v-icon size="18">mdi-phone-outline</v-icon>{{ customer.phone }}</a>
        </div>
      </template>
      <p v-else-if="!hasContact" class="tn-muted mb-0">{{ emptyText }}</p>

      <div v-if="hasContact" :class="{ 'tn-subsection': customer }">
        <div class="tn-subsection__title">Contact on the booking</div>
        <div class="tn-contact" :class="{ 'mt-1': !customer }">
          <span v-if="contact.contact_name"><v-icon size="18">mdi-account-outline</v-icon>{{ contact.contact_name }}</span>
          <a v-if="contact.contact_email" :href="'mailto:' + contact.contact_email"><v-icon size="18">mdi-email-outline</v-icon>{{ contact.contact_email }}</a>
          <a v-if="contact.contact_phone" :href="'tel:' + contact.contact_phone"><v-icon size="18">mdi-phone-outline</v-icon>{{ contact.contact_phone }}</a>
        </div>
        <p v-if="contact.special_requests" class="tn-request">“{{ contact.special_requests }}”</p>
      </div>

      <div v-if="leadGuest" class="tn-subsection">
        <div class="tn-subsection__title">{{ leadGuestLabel }}</div>
        <div class="tn-person__name">{{ leadGuest }}</div>
      </div>

      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CustomerPanel',
  props: {
    customer: { type: Object, default: null },
    contact: { type: Object, default: null },
    leadGuest: { type: String, default: null },
    leadGuestLabel: { type: String, default: 'Name on the reservation' },
    emptyText: { type: String, default: 'No customer account is linked to this booking.' }
  },
  computed: {
    hasContact () {
      const c = this.contact
      return !!(c && (c.contact_name || c.contact_email || c.contact_phone || c.special_requests))
    }
  },
  methods: {
    initials (name) {
      return String(name || '?').split(' ').filter(Boolean).slice(0, 2).map(p => p.charAt(0).toUpperCase()).join('') || '?'
    }
  }
}
</script>
